import React, { useEffect, useState } from "react";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { ToolButton } from "../../../../components";
import { hideAlert, showAlert } from "../../../../components/alert/Alert";
import { AlertTypeEnum } from "../../../../enums";
import { IToolButtonProps } from "../../../../interfaces";
import { publish, useStateReducer } from "../../../../hooks";
import { UserPermissions } from "../../../../definitions";
import {  securityService } from "../../../../_global/services";
import { userDataService } from "../../services";

export default function ExportButton({ config }: IToolButtonProps) {
  const navigate = useNavigate();
  const { id: moduleId } = config;
  const [state, setState] = useStateReducer({ id: "", isOpened: false });
  const [options, setOptions] = useState<any>([]);

  const alertTopic = "__alert_internal";
  const content = (<>
    Are you sure you want to export all user data?
    {/* <TextField style={{ width: '92%' }}
      label="FileName"
      // error={state.id.length > 0 ? false : true}
      onChange={(e) => { setState({ id: e.target.value }); }}      
    /> */}
  </>);

  const handleYes = async () => {
    await userDataService.export();

    hideAlert();
  };

  useEffect(() => {
    setOptions([
      { text: "No", onClick: () => { setState({ id: "", isOpened: false }); hideAlert(); } },
      { text: "Yes", onClick: handleYes, primary: true }
    ])

    if (state.isOpened)
      publish(alertTopic, {
        content, options: {
          actions: options,
          type: AlertTypeEnum.Info
        }
      });
  }, [state]);

  const handleClick = () => {
    setState({ isOpened: true });
    showAlert({
      content: content,
      options: {
        actions: options,
        type: AlertTypeEnum.Info
      }
    });
  };

  return (
    <ToolButton
      text="Export"
      icon={faSquarePlus}
      primary
      raised
      onClick={handleClick}
      invalid={!securityService.checkRoleAccess(UserPermissions.editCards)}
    />
  );
}
